<template>
  <b-modal
    id="payment-cancel-modal"
    ref="payment-cancel-modal"
    centered
    @show="show"
    @hidden="visible = false"
    @ok="handleOk"
    body-class="nice-modal"
    :visible="visible"
    :ok-title="$t('button.close')"
    no-close-on-backdrop
    no-close-on-esc
    ok-only
    title=""
  >
    <div class="text-center">
      <div class="icon mb-3"></div>
      <h2 class="mb-4">{{ $t('license.payment_canceled.h2') }}</h2>
      <div class="mb-5">{{ $t('license.payment_canceled.more') }} <a :href="URL_SUPPORT_QUESTION" class="nowrap">{{ $t('license.payment_canceled.ask_support') }}</a>.</div>
      <div class="text-secondary mb-4">{{ $t('license.payment_success.more') }} <a :href="URL_QUICK_START_GUIDE" class="nowrap">{{ $t('license.payment_success.quick_start') }}</a>.</div>
    </div>
  </b-modal>
</template>

<script>

import {URL_QUICK_START_GUIDE, URL_SUPPORT_QUESTION} from "@/globals";

export default {
  name: "PaymentCancelModal",
  components: {},
  props: ["licenseWrapper"],
  data() {
    return {
      wrapped: this.licenseWrapper,
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleOk() {

    },

  },
  created () {
    this.URL_QUICK_START_GUIDE = URL_QUICK_START_GUIDE
    this.URL_SUPPORT_QUESTION = URL_SUPPORT_QUESTION

  }
};
</script>

<style scoped>
.icon {
  min-width: 100px;
  min-height: 100px;
  background-image: url(/sad_cat.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>